"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
let Parse;
Parse = require("parse");
const Track_1 = require("./Track");
const Keys_1 = require("./constants/Keys");
const User_1 = require("./User");
const initServer = data => __awaiter(void 0, void 0, void 0, function* () {
  const prod = data.env === "production" ? true : false;
  const appId = prod ? "QY5gVZmeai8ug19nHGA9AoFmuPU26k04tGJeV1wT" : "ozhwh3DH5uWPJcolow2Ao2skHzLvckB4tWVB34fA";
  const javascriptKey = prod ? "KptAcmIZMegEb9bjMuoBcyNrQKFliHagI9nUKM7a" : "1rjYuTUJEGUSmdX7DtAqr5V31FPygQ8L6TkWI2B9";
  const serverUrl = prod ? "https://aua.b4a.app" : "https://devaua.b4a.app";
  Keys_1.default.setServerUrl(serverUrl);
  Keys_1.default.setEnv(prod ? "prod" : "dev");
  Keys_1.default.setStripeKey(prod ? "pk_live_T2DcYW6yiKH7lCUr26uZLm1x" : "pk_test_dQq2KP56pzzgXpx0kD4vrwIl");
  Keys_1.default.setStripeDonationKey(prod ? "pk_live_w4RspbgSXSIPwYl5OPUnnBpQ" : "pk_test_uBHC7aHg3yXX6knX5mRBHa5l");
  Keys_1.default.setApplicationId(appId);
  Keys_1.default.setRestApiKey(prod ? "iChNOEgTUW2fTobWjfYURlsDspoJbaVQ540JepB7" : "ZLZFR8X8a49hsMnnfbztRsB2dHbSCBIf6lyBCyv4");
  Keys_1.default.setDisableTrack(data.disableTrack);
  Keys_1.default.setUtmData(data.utmData);
  Parse.initialize(appId, javascriptKey);
  Parse.serverURL = serverUrl;
  try {
    const sessionToken = yield getSessionToken();
    if (sessionToken) {
      const currentUser = yield User_1.default.currentAsync();
      if (currentUser) {
        //Init Mixpanel
        Track_1.default.init(prod, currentUser.data);
        return {
          data: currentUser.data
        };
      } else {
        //Init Mixpanel
        Track_1.default.init(prod);
        return {
          data: undefined
        };
      }
    } else {
      //Init Mixpanel
      Track_1.default.init(prod);
      return {
        data: undefined
      };
    }
  } catch (e) {
    console.error(e);
    return {
      error: e
    };
  }
});
const initLiveQueryServer = env => {
  const prod = env && env === "production" ? true : false;
  const appId = prod ? "QY5gVZmeai8ug19nHGA9AoFmuPU26k04tGJeV1wT" : "ozhwh3DH5uWPJcolow2Ao2skHzLvckB4tWVB34fA";
  const liveQueryserverUrl = prod ? "wss://aua.b4a.app" : "wss://devaua.b4a.app";
  const javascriptKey = prod ? "KptAcmIZMegEb9bjMuoBcyNrQKFliHagI9nUKM7a" : "1rjYuTUJEGUSmdX7DtAqr5V31FPygQ8L6TkWI2B9";
  var client = new Parse.LiveQueryClient({
    applicationId: appId,
    serverURL: liveQueryserverUrl,
    javascriptKey: javascriptKey
  });
  client.open();
  return client;
};
const getEnv = () => {
  return Keys_1.default.getEnv();
};
const getStripeKey = () => {
  return Keys_1.default.getStripeKey();
};
const getStripeDonationKey = () => {
  return Keys_1.default.getStripeDonationKey();
};
const getSessionToken = () => __awaiter(void 0, void 0, void 0, function* () {
  //Get session token
  try {
    const currentSession = yield Parse.Session.current();
    if (currentSession) {
      const sessionToken = currentSession.get("sessionToken");
      Keys_1.default.setToken(sessionToken);
      return sessionToken;
    } else {
      Keys_1.default.setToken(undefined);
      return undefined;
    }
  } catch (e) {
    console.error(e);
    Keys_1.default.setToken(undefined);
    yield Parse.User.logOut();
    return undefined;
  }
});
const getConfig = () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const config = yield Parse.Config.get();
    return config;
  } catch (error) {
    console.error("Error fetching Parse config:", error);
    throw error;
  }
});
const getServerUrl = () => {
  return Keys_1.default.getServerUrl();
};
exports.default = {
  initServer,
  initLiveQueryServer,
  getEnv,
  getStripeKey,
  getStripeDonationKey,
  getConfig,
  getServerUrl
};